(function($){

	/**
	*	MutationObserverをwrapし、要素の属性を監視するクラスです
	*	@name AttributeObserver
	*	@memberof OH
	* @class
	*/
	OH.AttributeObserver = function(element, attribute){
		var Observer = function(callback){
			var interval = 11;
			var timer = null;

			this.observe = function(elm, attr){
				var valueStamp = elm.getAttribute(attr);
				timer = window.setInterval(function(){
					var current = elm.getAttribute(attr)
					if(current != valueStamp){
						valueStamp = current;
						if(!!callback && typeof callback == "function"){
							callback(elm);
						}
					}
				}, interval);
			};

			this.disconnect = function(){
				if(!!timer){
					window.clearInterval(timer);
					timer = null;
				}
			};
		};

		var obs;

		this.start = function(task){
			if(!!window.MutationObserver){
				obs = new MutationObserver(task);
				obs.observe(element, { attributes: true, attributeFilter : [ attribute ] });
			}
			else{
				obs = new Observer(task);
				obs.observe(element, attribute);
			}
		};

		this.stop = function(){
			if(!!obs){
				obs.disconnect();
			}
		};
	}

})(jQuery);
